import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

import { IRedeemActivity } from '@models/IMembership';

const initialState: {
  redeemActivities: IRedeemActivity[];
  loading: boolean;
  error: string | null;
} = {
  redeemActivities: [],
  loading: false,
  error: null,
};

export const RedeemActivityStore = signalStore(
  withState(initialState),
  withMethods((store) => ({
    setRedeemActivities: (redeemActivities: IRedeemActivity[]) => {
      patchState(store, (prev) => ({
        ...prev,
        redeemActivities,
      }));
    },

    setLoading: (loading: boolean) => {
      patchState(store, (store) => ({
        ...store,
        loading,
      }));
    },
    setError: (error: string | null) => {
      patchState(store, (store) => ({
        ...store,
        error,
      }));
    },
  })),
);
